import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';

export const FormMicThermometer = ({
  name_thermometer,
  abbreviation,
  internal_thermometer,
  correction_factor,
  loading,
  handleInputChange,
  onSubmit,
  button,
}) => {
  return (
    <Form role="form" onSubmit={onSubmit}>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label>
              Nombre del Termómetro <span style={{ color: "#0079C7" }}>*</span>
            </Label>
            <Input
              type="text"
              name="name_thermometer"
              value={name_thermometer}
              onChange={handleInputChange}
              autoComplete="off"
              className="form-control form-control-sm input-air-primary"
            />
          </FormGroup>

           <FormGroup>
            <Label>
              Termómetro Interno
            </Label>
            <Input
              type="text"
              name="internal_thermometer"
              value={internal_thermometer}
              onChange={handleInputChange}
              autoComplete="off"
              className="form-control form-control-sm input-air-primary"
            />
          </FormGroup>

         
        </Col>

        <Col md="6">
       <FormGroup>
            <Label>
              Abreviación <span style={{ color: "#0079C7" }}>*</span>
            </Label>
            <Input
              type="text"
              name="abbreviation"
              value={abbreviation}
              onChange={handleInputChange}
              autoComplete="off"
              className="form-control form-control-sm input-air-primary"
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Factor de Corrección <span style={{ color: "#0079C7" }}>*</span>
            </Label>
            <Input
              type="text"
              name="correction_factor"
              value={correction_factor}
              onChange={handleInputChange}
              autoComplete="off"
              className="form-control form-control-sm input-air-primary"
            />
          </FormGroup>
        </Col>
      </Row>

      <ModalFooter>
        <Button
          size="sm"
          outline
          color="primary"
          type="submit" 
          disabled={loading}
          className={loading ? "progress-bar-animated progress-bar-striped" : ""}
        >
          {button}
        </Button>
      </ModalFooter>
    </Form>
  );
};
